import React, { ReactElement } from "react";
import { Flex, HelpIndicator, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { amlStatusFieldLabel, pepTooltip } from "../styles_vanilla.css";

export const FieldLabel = ({
  label,
  tooltip,
}: {
  label: string;
  tooltip?: ReactElement | string;
}) => (
  <Flex alignItems="center" gap={4}>
    <Text variant="regular-md" className={amlStatusFieldLabel}>
      {label}
    </Text>
    {tooltip && (
      <HelpIndicator id={`aml_tooltip`} content={tooltip} className={pepTooltip}>
        <Icon type="question-circle" variant="outline" color={Colors.Neutral600} size="small" />
      </HelpIndicator>
    )}
  </Flex>
);
